export default __webpack_public_path__ + "static/media/coin_api_reactJS.2097d283.PNG";